import React, { useState, useRef, useCallback } from 'react';
import axios from '../../../axios';
import ModalContentBaseXl from '../../components/modal/modal_content_base_xl';

const ChildCircleTab = ({ data, setChildCircles, circleId, isCircleMember }) => {
  const { child_circles, usersCircles } = data;
  const [selectedChildCircleId, setSelectedChildCircleId] = useState(null);
  const messageModalRef = useRef(null);
  const [message, setMessage] = useState("");
  const modalRef = useRef(null);

  const closeModal = useCallback(() => {
    modalRef.current.closeModal();
  }, []);

  const openModal = useCallback(() => {
    modalRef.current.openModal();
  }, []);

  const closeMessageModal = useCallback(() => {
    messageModalRef.current.closeModal();
    location.reload();
  }, []);

  const updateChildCircle = useCallback((childCircleId) => {
    axios.post(`/api/circle/create_relation`, { parent_id: circleId, child_id: childCircleId })
      .then((response) => {
        setChildCircles(prev => [...prev, response.data]);
        closeModal();
        setMessage("子サークルとして紐づけられました！");
        messageModalRef.current.openModal();
      })
      .catch((error) => {
        console.error(error);
        closeModal();
        setMessage("エラーが発生しました。もう一度お試しください。");
        messageModalRef.current.openModal();
      });
  }, [circleId, setChildCircles, closeModal]);

  return (
    <div className="my-4">
      <div style={{ marginTop: "20px", maxWidth: "900px", margin: "0 auto" }}>
        <div>
          {child_circles.map((child_circle, index) => (
            <a
              key={index}
              href={`/circle/${child_circle.id}`}
              style={{
                textDecoration: "none",
              }}
            >
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "25px",
                  marginBottom: "15px",
                  backgroundColor: "#f3f3f3",
                  borderRadius: "8px",
                }}
              >
                <div style={{ fontSize: "16px", fontWeight: "bold", color: "#333", display: "flex", alignItems: "center" }}>
                  {child_circle.is_company_owned && (
                    <span className="icon-tunagate_official_sm" style={{ marginRight: "3px" }}></span>
                  )}
                  {`${child_circle.name}`}
                </div>
                <img
                  src="/img/tunagate_logo.svg"
                  alt="icon"
                  style={{
                    height: "30px",
                    width: "30px",
                    objectFit: "contain",
                  }}
                />
              </div>
            </a>
          ))}
        </div>
      </div>
      {isCircleMember && (
        <div className="d-flex justify-content-end">
          <button
            className="a-button a-button__top a-button--orange text-white mb-2"
            onClick={openModal}
            style={{ maxWidth: '236px', textAlign: 'center' }}
          >
            + 自分のサークルを紐づける
          </button>
        </div>
      )}
      <ModalContentBaseXl
        ref={modalRef}
        previewContent={null}
        modalContent={
          <div className="container col-md-8 col-lg-8 mt-5">
            <p className="pt-2 form-label text-fz-20px text-fw-bold text-black-50 text-center">
              他のサークルをこのサークルに紐づける
            </p>
            <p className="text-fz-14px text-black-50 my-0 text-center">
              （選択したサークルは子サークルして紐づけられます。）
            </p>
            <p className="text-fz-14px text-black-50 mb-3 text-center">
              下記よりサークルを選択してください。
            </p>
            <div className="card-body p-0">
              <ul
                className="row flex-nowrap overflow-auto px-2 pt-3"
                style={{ listStyle: 'none' }}
              >
                {usersCircles && usersCircles.length > 0 ? (
                  usersCircles.map((circle) => (
                    <li key={circle.id} className="">
                      <label
                        className="circle-container"
                        style={{
                          border:
                            selectedChildCircleId === circle.id ? '5px solid #FF6467' : 'none',
                        }}
                        onClick={() => setSelectedChildCircleId(circle.id)}
                      >
                        <img
                          src={`${circle.main_image_thumb}`}
                          className="circle-image"
                          alt="サークル画像"
                        ></img>
                        <div className="circle-overlay"></div>
                        <div className="circle-content">
                          <div className="circle-name-container">
                            <span
                              className="circle-name line-2"
                              style={{ position: 'absolute', bottom: '6%' }}
                            >
                              {circle.name}
                            </span>
                          </div>
                        </div>
                      </label>
                    </li>
                  ))
                ) : (
                  <p className="text-center w-100 text-fz-14px text-black-50">
                    追加可能なサークルがありません。
                  </p>
                )}
              </ul>
            </div>
            <p className="text-fz-14px text-black-50 mb-3 text-center">
              ※紐づけの解除は、紐づけたサークルの、サークル編集画面から行ってください。
            </p>
            {selectedChildCircleId && (
              <div
                className="w-100"
                style={{ paddingRight: '10px', paddingLeft: '10px', marginTop: '20px' }}
              >
                <button
                  type="button"
                  className="mx-1 a-button a-button__top a-button--orange w-100 mb-3"
                  onClick={() => updateChildCircle(selectedChildCircleId)}
                >
                  このサークルを紐づける
                </button>
              </div>
            )}
            <div className="text-center" style={{ paddingBottom: '65px' }}>
              <button
                type="button"
                className="mx-1 a-button a-button__top a-button__top--outline"
                style={{ width: '130px', margin: '0 auto' }}
                onClick={closeModal}
              >
                キャンセル
              </button>
            </div>
          </div>
        }
      />
      {/* メッセージ用モーダル */}
      <ModalContentBaseXl
        ref={messageModalRef}
        previewContent={null}
        modalContent={
          <div className="container col-md-5 col-lg-5 my-3 text-center">
            <p className="pt-2 form-label text-fz-20px text-fw-bold text-black-50 text-center">
              {message}
            </p>
            <div style={{ marginTop: '20px' }}>
              <button
                type="button"
                className="mx-1 a-button a-button__top a-button__top--outline"
                style={{ width: '130px', margin: '0 auto' }}
                onClick={closeMessageModal}
              >
                閉じる
              </button>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default ChildCircleTab;